import React from "react";
import { useMagnetic } from "../hooks/useMagnetic";

/**
 * Magnetic wrapper — attaches subtle cursor-attraction to the inner element.
 * Use as a presentational container around a button or link.
 */
export default function MagneticButton({ strength = 14, className = "", children, ...rest }) {
  const ref = useMagnetic(strength);
  return (
    <span
      className={`inline-block transition-transform duration-300 ease-out ${className}`}
      style={{ willChange: "transform" }}
      {...rest}
    >
      <span ref={ref} className="inline-block">
        {children}
      </span>
    </span>
  );
}
